import {CreditInvoiceItem} from './CreditInvoiceItem';

export class Invoice {
  /**
   * Invoice statuses
   */
  static INVOICE_PAID = {key: 'paid', value: 'Paid'};
  static INVOICE_OPEN = {key: 'open', value: 'Open'};
  static INVOICE_OVERDUE = {key: 'overdue', value: 'Overdue'};
  static INVOICE_CREDITED = {key: 'credited', value: 'Credited'};
  static INVOICE_PARTIAL_PAID = {key: 'partial_paid', value: 'Partial paid'};
  static STATUS_CREDIT_INVOICE = {key: 'credit_invoice', value: 'Credit invoice'};

  /**
   * Order Properties
   */
  public partialPaid: string;
  public status: string;
  public invoiceLayout: number;
  public creditInvoiceItems: CreditInvoiceItem[] = [];
  public creditInvoices: any[] = [];
  public amount: number;
  public amountEx: number;
  public isCredit: boolean;
}
